import FluxUtils from 'flux/utils';
import Immutable from 'immutable';

import WebAppsActions from 'sharedreact/actions/WebAppsActions';
import type { ActionType } from 'sharedreact/actions/generic/actions';
import WebAppsConstants from 'sharedreact/constants/WebAppsConstants';
import type WebApp from 'sharedreact/data/WebApp';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';

const _didInitialFetch: boolean = false;

const Content: {
  isSlideOutVisible: boolean,
  items: Immutable.List<WebApp>,
  allAppsUrl?: string,
  currentWorkspace: string,
} = {
  isSlideOutVisible: false,
  items: Immutable.List(),
  allAppsUrl: undefined,
  currentWorkspace: ''
};

class State extends Immutable.Record(Content) {
}

class WebAppsStore extends FluxUtils.ReduceStore<State, ActionType> {
  constructor () {
    super(AppDispatcher);
  }

  override getInitialState (): State {
    return new State();
  }

  getItems (): Immutable.List<WebApp> {
    return this.getState().items;
  }

  getAllAppsUrl (): string | undefined {
    return this.getState().allAppsUrl;
  }

  getCurrentWorkspace (): string {
    return this.getState().currentWorkspace;
  }

  override reduce (state: State, action: ActionType): State {
    switch (action.actionType) {
      case WebAppsConstants.SHOW: {
        if (!_didInitialFetch) {
          WebAppsActions.fetch();
        }

        return state.set('isSlideOutVisible', true)
          .set('currentWorkspace', action.currentWorkspace)
          .set('allAppsUrl', action.allAppsUrl);
      }
      case WebAppsConstants.HIDE: {
        return state.set('isSlideOutVisible', false);
      }
      case WebAppsConstants.GET_SUCCESS: {
        return state.set('items', action.items);
      }
    }
    return state;
  }
}

export default new WebAppsStore();
